import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type PageVisibilityAudienceBySlugQueryVariables = Types.Exact<{
  payload: Types.PageContainerBySlugPayload;
}>;

export type PageVisibilityAudienceBySlugQuery = {
  __typename?: 'Query';
  pageContainerBySlug?: { __typename?: 'PageContainer'; id: string; labelIds: Array<string>; personIds: Array<string> } | null;
};

export const PageVisibilityAudienceBySlugDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PageVisibilityAudienceBySlug' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageContainerBySlugPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageContainerBySlug' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'ObjectValue', fields: [{ kind: 'ObjectField', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }] },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePageVisibilityAudienceBySlugQuery__
 *
 * To run a query within a React component, call `usePageVisibilityAudienceBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageVisibilityAudienceBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageVisibilityAudienceBySlugQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function usePageVisibilityAudienceBySlugQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<PageVisibilityAudienceBySlugQuery, PageVisibilityAudienceBySlugQueryVariables>,
) {
  return ApolloReactHooks.useQuery<PageVisibilityAudienceBySlugQuery, PageVisibilityAudienceBySlugQueryVariables>(PageVisibilityAudienceBySlugDocument, baseOptions);
}
export function usePageVisibilityAudienceBySlugLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PageVisibilityAudienceBySlugQuery, PageVisibilityAudienceBySlugQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<PageVisibilityAudienceBySlugQuery, PageVisibilityAudienceBySlugQueryVariables>(PageVisibilityAudienceBySlugDocument, baseOptions);
}
export type PageVisibilityAudienceBySlugQueryHookResult = ReturnType<typeof usePageVisibilityAudienceBySlugQuery>;
export type PageVisibilityAudienceBySlugLazyQueryHookResult = ReturnType<typeof usePageVisibilityAudienceBySlugLazyQuery>;
export type PageVisibilityAudienceBySlugQueryResult = Apollo.QueryResult<PageVisibilityAudienceBySlugQuery, PageVisibilityAudienceBySlugQueryVariables>;
